import { StyleRulesCallback, Theme } from '@material-ui/core';

const GateScheduleTheme: StyleRulesCallback<Theme, Record<string, never>> = (theme: Theme) => ({
  containerContent: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    padding: theme.spacing.unit,
    minHeight: '70vh',
    position: 'relative',
  },
  containerRoot: {
    paddingLeft: 0,
    paddingRight: 0,
  },
});

export default GateScheduleTheme;
